import React, { useMemo } from "react";
import SimpleTable from "../../../../../../../shared/components/common/ui/SimpleTable";
import { TEMPLATE_COLUMNS } from "./constants";

const TemplatesGrid = ({
  rows,
  onPreview,
  onSelectionChange,
  onSelect,
  selectionModel,
}) => {
  const actions = useMemo(
    () => [
      {
        label: "Visualizar",
        icon: "view",
        isVisible: () => true,
        onClick: (row) => onPreview?.(row),
      },
      {
        label: "Selecionar",
        icon: "click",
        isVisible: (row) => row.status === "APPROVED",
        onClick: (row) => {
          onSelect?.(row);
        },
      },
    ],
    [onPreview, onSelect]
  );

  return (
    <SimpleTable
      data={rows}
      columns={TEMPLATE_COLUMNS}
      actions={actions}

      mode="selection"
      selectionModel={selectionModel}        
      onSelectionChange={onSelectionChange} 

      hideFooter
      hideHeaderActions
    />
  );
};

export default TemplatesGrid;
